<button
  type="{{ label && label.includes('Cancel') ? 'button' : 'submit' }}"
  class="{{ colorClasses }}"
  (click)="doClick()"
  [disabled]="disabled"
>
  <img class="mr-1 mb0-5" *ngIf="btnImage" [src]="btnImage" alt="" />
  {{ label }}
</button>

<!-- Usage -->

<!-- <app-base-button
  label="Hello!"
  [colorClasses]="'custom__btn custom__btn-brand custom-btn-lg btn'"
  btnImage="/assets/arrow-left.svg"
></app-base-button> -->
